<template>
  <div class="not-us" v-bind:class="{ flash: flash }">
    <p class="text-center">
      {{ $t("geofence") }}
    </p>
  </div>
</template>

<script>
import FlixLatinoLogo from "@/components/icons/flixLatinoLogo.vue";
export default {
  name: "NotUs",
  components: {},
  data() {
    return {
      flash: false,
    };
  },
  created() {
    this.$bus.on("notUsBlink", () => {
      this.flash = true;
      setTimeout(() => {
        this.flash = false;
      }, 1000);
    });
  },
};
</script>

<style lang="scss" scoped>
.not-us {
  background: #d51f27;
  line-height: 2em;
}
.flash {
  background: #d51f27;
  color: #fff;
  animation: flash10 1s linear 1 forwards;
}

@keyframes flash10 {
  0%,
  10%,
  20%,
  30%,
  40%,
  50% {
    background: #d51f27;
    color: #fff;
  }

  5%,
  15%,
  25%,
  35%,
  45%,
  55% {
    background: #fff;
    color: #d51f27;
  }
}
</style>
